// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"d2c8118d","379":"ee2ff311","703":"5f54cf46","787":"4c83abce","827":"0d8155e3"}[chunkId] + ".chunk.js";
};